// Featured products data
export const featuredProducts = [
  {
    id: 1,
    name: "Silk Scarf",
    description: "Elegant silk scarf with a unique pattern.",
    image: "/images/silk-scarf.jpg",
  },
  {
    id: 2,
    name: "Cashmere Sweater",
    description: "Luxurious cashmere sweater for ultimate comfort.",
    image: "/images/cashmere-sweater.jpg",
  },
  {
    id: 3,
    name: "Leather Handbag",
    description: "Stylish leather handbag, perfect for any occasion.",
    image: "/images/leather-handbag.jpg",
  },
  {
    id: 4,
    name: "Wool Coat",
    description: "Classic wool coat to keep you warm and chic.",
    image: "/images/wool-coat.jpg",
  },
];

// Categories data
export const categories = [
  {
    id: 1,
    name: "Women Clothing",
    image: "/assets/photos/Women_Sets/Prāna Set/1.jpg",
  },
  {
    id: 2,
    name: "Men Clothing",
    image: "/assets/photos/Men_Shirts/Men _ Shirt 1/LM-49.jpg",
  },
  {
    id: 3,
    name: "Women Sets Clothing",
    image: "/assets/photos/Women_Sets/Terre Somā Set/LM-3_reblum.jpg",
  },
];

//ExploreAll data
export const Men_Shirts = [
  {
    id: 1,
    name: "Aran Shirt",
    image: "/assets/photos/Men_Shirts/Men _ Shirt 1/LM-35.jpg",
  },
  {
    id: 1,
    name: "Aran Shirt",
    image: "/assets/photos/Men_Shirts/Men _ Shirt 1/LM-37.jpg",
  },
  {
    id: 1,
    name: "Aran Shirt",
    image: "/assets/photos/Men_Shirts/Men _ Shirt 1/LM-49.jpg",
  },
  {
    id: 2,
    name: "Ivora Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 2_Ivorā shirt/LM-30.jpg",
  },
  {
    id: 2,
    name: "Ivora Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 2_Ivorā shirt/LM-31.jpg",
  },
  {
    id: 2,
    name: "Ivora Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 2_Ivorā shirt/LM-34.jpg",
  },
  {
    id: 3,
    name: "Kora Leaf Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 3/LM-58.jpg",
  },
  {
    id: 3,
    name: "Kora Leaf Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 3/Shirt - 3.1.png",
  },
  {
    id: 3,
    name: "Kora Leaf Shirt",
    image: "/assets/photos/Men_Shirts/Men_Shirt 3/Shirt- 3.2.png",
  },
];

//ExploreAll data
export const Men_Trousers = [
  {
    id: 1,
    name: "Sama Pants",
    image: "/assets/photos/Men_Trousers/LM-41.jpg",
  },
  {
    id: 1,
    name: "Sama Pants",
    image: '/assets/photos/Men_Trousers/LM-42.jpg',
  },
  {
    id: 1,
    name: 'Sama Pants',
    image: '/assets/photos/Men_Trousers/LM-52.jpg',
  },
];

//ExploreAll data
export const Women_Bottoms = [
  {
    id: 1,
    name: "Skorts",
    image: "/assets/photos/Women_Bottoms/Skorts/1.png",
  },
  {
    id: 1,
    name: "Skorts",
    image: "/assets/photos/Women_Bottoms/Skorts/2.png",
  },
  {
    id: 1,
    name: "Skorts",
    image: "/assets/photos/Women_Bottoms/Skorts/3.png",
  },
  {
    id: 2,
    name: "Vata Skirt-pants",
    image: "/assets/photos/Women_Bottoms/Vāta skirt-Pants/LM-12.jpg",
  },
  {
    id: 2,
    name: "Vata Skirt-pants",
    image: "/assets/photos/Women_Bottoms/Vāta skirt-Pants/LM-14.jpg",
  },
  {
    id: 2,
    name: "Vata Skirt-pants",
    image: "/assets/photos/Women_Bottoms/Vāta skirt-Pants/LM-114.jpg",
  },
];

//ExploreAll data
export const Women_Sets = [
  {
    id: 1,
    name: "Nirvana Set",
    image: "/assets/photos/Women_Sets/Nirvānā Set/LM-63.jpg",
  },
  {
    id: 1,
    name: "Nirvana Set",
    image: "/assets/photos/Women_Sets/Nirvānā Set/LM-64.jpg",
  },
  {
    id: 1,
    name: "Nirvana Set",
    image: "/assets/photos/Women_Sets/Nirvānā Set/LM-82.jpg",
  },
  {
    id: 2,
    name: "Prana Set",
    image: "/assets/photos/Women_Sets/Prāna Set/1.jpg",
  },
  {
    id: 2,
    name: "Prana Set",
    image: "/assets/photos/Women_Sets/Prāna Set/2.png",
  },
  {
    id: 2,
    name: "Prana Set",
    image: "/assets/photos/Women_Sets/Prāna Set/LM-123.jpg",
  },
  {
    id: 3,
    name: "Terre Soma Set",
    image: "/assets/photos/Women_Sets/Terre Somā Set/3.png",
  },
  {
    id: 3,
    name: "Terre Soma Set",
    image: "/assets/photos/Women_Sets/Terre Somā Set/LM-3_reblum.jpg",
  },
  {
    id: 3,
    name: "Terre Soma Set",
    image: "/assets/photos/Women_Sets/Terre Somā Set/LM-6_reblum.jpg",
  },
  {
    id: 4,
    name: "Vana Set",
    image: "/assets/photos/Women_Sets/Vanā Set/LM-59.jpg",
  },
  {
    id: 4,
    name: "Vana Set",
    image: "/assets/photos/Women_Sets/Vanā Set/LM-60.jpg",
  },
  {
    id: 4,
    name: "Vana Set",
    image: "/assets/photos/Women_Sets/Vanā Set/LM-61.jpg",
  },
  {
    id: 5,
    name: "Veda Set",
    image: "/assets/photos/Women_Sets/Vedā Set/2.png",
  },
  {
    id: 5,
    name: "Veda Set",
    image: "/assets/photos/Women_Sets/Vedā Set/LM-66.jpg",
  },
  {
    id: 5,
    name: "Veda Set",
    image: "/assets/photos/Women_Sets/Vedā Set/LM-76.jpg",
  },
];

//ExploreAll data
export const Women_Shirts_Tops = [
  // {
  //   id: 1,
  //   name: "Kora Bloom Top",
  //   image: '/assets/photos/Women_Shirts_Tops/Sirā Top/1.png',
  // },
  // {
  //   id: 1,
  //   name: "Kora Bloom Top",
  //   image: '/assets/photos/Women_Shirts_Tops/Sirā Top/1.png',
  // },
  // {
  //   id: 1,
  //   name: "Kora Bloom Top",
  //   image: '/assets/photos/Women_Shirts_Tops/Sirā Top/1.png',
  // },
  {
    id: 2,
    name: "Sira Top",
    image: "/assets/photos/Women_Shirts_Tops/Sirā Top/1.png",
  },
  {
    id: 2,
    name: "Sira Top",
    image: "/assets/photos/Women_Shirts_Tops/Sirā Top/LM-70.jpg",
  },
  {
    id: 2,
    name: "Sira Top",
    image: "/assets/photos/Women_Shirts_Tops/Sirā Top/LM-71.jpg",
  },
];
